import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Monthly.css';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/db';
import { sortReportItems } from '../utils/helpers';

export default function Monthly() {
  const { warehouseId, warehouseName, teamRoles } = useAuth();
  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Split warehouse Name
  let topName = "";
  let bottomName = "";
  if (warehouseName) {
    const parts = warehouseName.split('-');
    if (parts.length > 1) {
      topName = parts[0].trim();
      bottomName = parts.slice(1).join('-').trim();
    } else {
      topName = warehouseName;
    }
  }

  useEffect(() => {
    if (teamRoles.includes('production')) {
      navigate('/production');
      return;
    }
    if (warehouseId) loadData();
  }, [warehouseId, teamRoles]);

  async function loadData() {
    setLoading(true);
    const [items, transactions] = await Promise.all([
      api.getItems(warehouseId),
      api.getTransactions(warehouseId)
    ]);

    const now = new Date();
    const currentMonth = now.toISOString().slice(0, 7); // YYYY-MMm

    // Filter month's transactions
    const monthTrans = transactions.filter(t => t.date.startsWith(currentMonth));

    // Build map
    // Build map
    const stats = items.map(item => {
      let incoming = 0;
      let outgoing = 0;

      monthTrans.forEach(t => {
        // 1. Standard In/Out
        if (t.item_id === item.name) {
          if (t.type === 'in') incoming += t.quantity;
          else if (t.type === 'out') outgoing += t.quantity;
        }

        // 2. Production Logic
        if (t.type === 'production') {
          // A. Produced Item -> Incoming
          if (t.item_id === item.name) {
            incoming += t.quantity;
          }
          // B. Raw Material (50kg) -> Outgoing (Consumed)
          if (item.name === 'سكر 50 كيلو') {
            outgoing += (t.consumed_50kg || 0);
          }
        }
      });

      const current = item.current_stock || 0;
      const opening = current - incoming + outgoing; // Logic checking: current is AFTER month? No, current is LIVE.
      // Issue: Monthly report usually wants "Start of Month" to "End of Month" or "Current".
      // Current implementation assumes 'current_stock' on item IS the value at the end of the period (which is today/now).
      // So Opening of the period = Current - Incoming(during period) + Outgoing(during period). 
      // This holds true if 'current' is truly current and period is "up to noww al fffdi".

      const available = opening + incoming;

      return {
        name: item.name,
        available,
        outgoing,
        current
      };
    });

    const sortedStats = sortReportItems(stats);

    setReportData(sortedStats);
    setLoading(false);
  }

  return (
    <div className="monthly-root" dir="rtl">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Link to="/home"><button className="btn">الرجوع</button></Link>
        <button className="btn" onClick={() => window.print()}>تحميل PDF</button>
      </div>
      <div className="container">
        {topName && <h2 style={{ textAlign: 'center', margin: '0 0 10px 0', color: '#555' }}>{topName}</h2>}
        <h1>{bottomName ? `${bottomName} ` : ''}التقرير الشهري ({(() => {
          const now = new Date();
          const months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
          return `${months[now.getMonth()]} ${now.getFullYear()}`;
        })()})</h1>
        {loading ? <p>جاري التحميل...</p> : (
          <table id="monthly-report-table">
            <thead>
              <tr>
                <th>م</th>
                <th>البيان (الصنف)</th>
                <th>الكميات الواردة + المخزون (المتاح)</th>
                <th>الكميات المنصرفة (الإجمالي)</th>
                <th>المخزون المتبقي (الرصيد النهائي)</th>
              </tr>
            </thead>
            <tbody>
              {reportData.map((row, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{row.name}</td>
                  <td>{row.available.toLocaleString('en-US')}</td>
                  <td>{row.outgoing.toLocaleString('en-US')}</td>
                  <td>{row.current.toLocaleString('en-US')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
